/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults interface.
 */
export function instanceOfFxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    if (!('PurchaseToken' in value) || value['PurchaseToken'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsFromJSON(json) {
    return FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
        'PurchaseToken': json['PurchaseToken'],
    };
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsToJSON(json) {
    return FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
        'PurchaseToken': value['PurchaseToken'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults.js.map